export enum ConfigTypeEnum {
  Setting = 1,
  Variable = 2,
}
